/**
 *
 * @author Russell Lilljedahl
 * @prettier
 *
 * @since 23.6
 *
 * */
import React from 'react'
import { TbMessages } from 'react-icons/tb'

/**
 * Image link to the CSM chatbot
 *
 * @property {string} link - Hyperlink to the CSM chatbot
 * */

const LGYMessageImage = ({ link }) => (
  <a className='csm-link' href={link} target='_blank' rel='noopener noreferrer' title='Virtual Assistant'>
    <TbMessages size={50} color='#0071bc' />
  </a>
)

export default LGYMessageImage
